import React, { CSSProperties, ReactNode } from 'react';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import { useKeycloak } from '@nic-react/auth';
import { useQuery } from '@tanstack/react-query';
import { isNullOrUndefined, setUrlToHTTPs } from '../../utils';
import { useAppendAuthorizationHeader } from '../../utils/connector/api-connector';
import Spinner from '../../components/Spinner/Spinner';
import Request from '../../model/Request';
import { fillRequest, useBuildActionInfo } from '../../components/Common';
import RequestViewController from './RequestViewController';
import PageHeader from '../../components/Header/PageHeader';
import MediaQuery from 'react-responsive';
import * as Types from '../../types/ResponseTypes';
import { ResponseType } from '../../types/ResponseTypes';
import IconMinus from '../../components/icons/IconMinus';
import IconPlus from '../../components/icons/IconPlus';
import Card from 'antd/es/card';
import { Page } from '../../types/PageInfo';
import { Property } from 'csstype';
import { useTranslation } from '@nic-react-i18n/core';
import ResponseLinks = ResponseType.ResponseLinks;
import {AppConf} from "../../AppConf";
import keycloak from "../../keycloak";


type FlexDirectionProperty = Property.FlexDirection
interface RegistryRequestsControllerI {}

interface RequestsLinkI {
    pageInfo?: Types.ResponseType.Page
    links?: Types.ResponseType.ResponseLinks
    direction?: FlexDirectionProperty
    expand: boolean
    handleExpand: (expand: boolean) => void
}


interface BuildActionInfoI {
    pageInfo: Page
    links: ResponseLinks
    direction: FlexDirectionProperty
}
const BuildActionInfo: React.FC<BuildActionInfoI> = (props) => {
    const {pageInfo, links, direction} = props
    return useBuildActionInfo(pageInfo??{} as Page, links,  direction)
}




export const RequestsLink: React.FC<RequestsLinkI> = (props) => {
    const {pageInfo, links, direction, handleExpand, expand} = props
    const {t} = useTranslation()
    const {keycloak} = useKeycloak()

    let comp = <></>;
    if (!isNullOrUndefined(pageInfo) && !isNullOrUndefined(links)) {
        let showIcon = (!isNullOrUndefined(direction) && direction === 'column');
        let extraComponent = <div/>;
        let showContent = ( direction === 'column') || (direction === 'row');
        let className = (direction === 'column' ? 'filter-card' : '');
        let title = (direction === 'column' ? t('requests.filters') : null);
        let style: CSSProperties = (direction === 'column' ? {} : {paddingTop: '5px', paddingBottom: '5px'});
        if (showIcon) {

            extraComponent = (
                <div
                    style={{
                        cursor: 'pointer'
                    }}
                    onClick={() => {
                        handleExpand(!expand)
                    }}
                >
                    {expand ? <IconMinus/> : <IconPlus/>}
                </div>
            );
        }
        if (keycloak.realm === 'registry') {
            comp = (
                <Card
                    className={className}
                    title={title}
                    styles={{body: style}}
                    extra={(direction === 'column' ? extraComponent : null)}
                >
                    {showContent && <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginBottom: (direction === 'column' ? '20px' : '')
                        }}
                    >
                        {<BuildActionInfo pageInfo={pageInfo ?? {} as Page} links={links ?? {} as ResponseLinks}
                                          direction={direction ?? 'row'}/>}
                    </div>
                    }
                </Card>
            )
        } else {
            comp = <></>
        }
    }
    return comp;


}

export const RegistryRequestsController: React.FC<RegistryRequestsControllerI> = (props) => {

    const [search] = useSearchParams()

    const [expand, setExpand] = React.useState(false)
    const header = useAppendAuthorizationHeader()

    const status = search.get('status') ?? ''
    const type = search.get('type') ?? ''
    const registrar = search.get('registrar') ?? ''
    const page = search.get('page')
    const size = search.get('size')
    const sort = search.get('sort')?? 'sort=created,desc'
    const query = createSearchParams(search).toString()
    const sortString = createSearchParams(sort).toString()



    const requestsData = useQuery({
        queryKey: ['requests', 'registry', `${status}`, `${type}`, `${page}`, `${size}`, `${registrar}`],
        queryFn: async () => {
            const {url, hateos:useHateos} = AppConf.getRootUrl(keycloak.realm??'')
            console.log('RequestData: ', useHateos)
            const data =
                await fetch(setUrlToHTTPs(`${url}/requests?${query}&${sortString}`), {...header})
            return data.json()
        }}
    )

    if (requestsData.isFetched) {
        console.log('REquestData. ', requestsData.data)
        const requests = requestsData.data
        const requestElements = (requests._embedded ? requests._embedded.requests : null);
        const extraInfo: Types.ResponseType.Page =  requests.page ?? {size: 0, totalElements: 0, totalPages: 0, number: 0};
        const extraLink: Types.ResponseType.ResponseLinks = requests._links ?? {first: null, last: null, self: null};


        const requestsList = new Array<ReactNode>();

        if (requestElements) {
            console.log('RequestElements: ', requestElements)
            requestElements.forEach((requestItem: any, i: number) => {
                console.log('Request: ', requestItem);
                let reqObj = new Request();
                fillRequest(reqObj, requestItem);
                requestsList.push(
                    <RequestViewController
                        key={i}
                        request={reqObj}

                    />
                )
            })

            return (
                <PageHeader
                    breadcrumb={[{label: 'Home', pathname: '/home'}, {label: 'requests', pathname: '/requests'}]}>
                    <MediaQuery component={'div'} minWidth={1135}>
                        <RequestsLink pageInfo={extraInfo} links={extraLink} expand={expand}
                                      handleExpand={(e: boolean) => {
                                          setExpand(e)
                                      }} direction={'row'}/>
                    </MediaQuery>

                    <MediaQuery component={'div'} minWidth={300} maxWidth={1134}>
                        <RequestsLink pageInfo={extraInfo} links={extraLink} expand={expand}
                                      handleExpand={(e: boolean) => {
                                          setExpand(e)
                                      }} direction={'column'}/>
                    </MediaQuery>

                    <div
                        style={{
                            marginTop: '5px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between'
                        }}
                    >
                        {requestsList}
                    </div>
                </PageHeader>
        )
        }
        }


        if (requestsData.isError) {
            return <span>Error</span>
        }

        return (
            <Spinner/>
        )
        }